import { PLAYER } from "../../common/constants.ts";
import { idb } from "../db/index.ts";
import { g } from "../util/index.ts";
import addFirstNameShort from "../util/addFirstNameShort.ts";
import {
	evaluateOffer,
	getMarket,
	getUserOffer,
} from "../core/contractNegotiation/market.ts";

// Free agents waiting to answer an offer from the user's team, with the competing bids.
// Shown in the Negotiations tab of the Free Agents page.
export const getPendingOffers = async () => {
	const userTid = g.get("userTid");
	const pending = (
		await idb.cache.players.indexGetAll("playersByTid", PLAYER.FREE_AGENT)
	).filter((p) => getUserOffer(p)?.tid === userTid);

	const players = await addFirstNameShort(
		await idb.getCopies.playersPlus(pending, {
			attrs: ["pid", "firstName", "lastName", "age", "injury", "watch", "jerseyNumber"],
			ratings: ["ovr", "pot", "skills", "pos"],
			season: g.get("season"),
			showNoStats: true,
			showRookies: true,
			fuzz: true,
		}),
	);

	const rows = [];
	for (const p of players) {
		const raw = pending.find((p2) => p2.pid === p.pid)!;
		const offer = getUserOffer(raw)!;
		const bids = (await getMarket(raw)).map((bid) => ({
			tid: bid.tid,
			abbrev: g.get("teamInfoCache")[bid.tid]?.abbrev ?? String(bid.tid),
			amount: bid.amount,
			exp: bid.exp,
		}));
		// His counter: what it takes today to beat the other offers
		const counter = (await evaluateOffer(raw, offer.amount, offer.exp)).required;
		rows.push({ ...p, offer, bids, counter });
	}
	return rows;
};
